import EJECT_TUBE_RACK_IMG from './images/mc_eject_tube.svg';

export function useMicroTooltipControls() {

  const getControlItems = (props) => {
    const newControlItems = [];

    if (props.count>0) {
      newControlItems.push({
        onClick: props.onEjectTubeRack,
        image: EJECT_TUBE_RACK_IMG,
      });
    } 
    return newControlItems;
  };

  return {getControlItems};
}
